var paragraph_default = {
  "fontElementMap": "_4WzZI",
  "elementSpacing": "TDYoH",
  "text": "EmMgw TDYoH",
  "child": "ko7kJ"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
